import { callApiWithToken } from "../utils/http_common";

const getUserList = ({ type = "" }) => {
  return callApiWithToken.get(`/v2/configurations/users`, {
    params: {
      type,
    },
  });
};

const getSupportedCurrencies = ({ direction = "" }) => {
  return callApiWithToken.get(`/v2/configurations/currencies`, {
    params: {
      direction,
    },
  });
};

const getPaymentMethods = ({ direction = "", beneficiaryType = "", currency = "" }) => {
  return callApiWithToken.get(`/v2/configurations/payment-methods`, {
    params: {
      direction,
      beneficiaryType,
      currency,
    },
  });
};

const getExchangeRate = ({ direction = "", amount = "", currency = "", balanceCurrency = "", paymentCode = "" }) => {
  return callApiWithToken.get(`/v2/exchange-rate/`, {
    params: {
      direction,
      amount,
      currency,
      balanceCurrency,
      paymentCode,
    },
  });
};

const createFiatPayoutOrder = (payload = {}) => {
  return callApiWithToken.post(`/v2/orders/fiat-payout`, {
    orderPayload: payload,
  });
};

const V2Service = {
  getUserList,
  getSupportedCurrencies,
  getPaymentMethods,
  getExchangeRate,
  createFiatPayoutOrder,
};

export default V2Service;
